module.exports = __webpack_public_path__ + "static/media/delete.4ca4d9d8.svg";